export default "__VITE_ASSET__DMCtkDtO__"